<div class="cr-timeline">
  <div class="cr-timeline-list" *ngIf="events.length; else empty">
    <section class="cr-timeline-row" *ngFor="let e of events; trackBy: trackByIndex" [ngClass]="'timeline-' + e.type">
      <span class="cr-timeline-node" [ngClass]="e.tone ? 'tone-' + e.tone : ''">{{ e.glyph }}</span>
      <div class="cr-timeline-copy">
        <div class="cr-timeline-event-title">{{ e.title }}</div>
        <div class="cr-timeline-byline">by <strong>{{ e.author }}</strong></div>
      </div>
      <div class="cr-timeline-when">
        <span>{{ e.date | date: 'dd-MM-yyyy' }}</span>
        <span>{{ e.date | date: 'HH:mm' }}</span>
      </div>
    </section>
  </div>
  <ng-template #empty>
    <div class="cr-timeline-empty">Nothing has happened on this proof yet.</div>
  </ng-template>
</div>
